import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

if (!window.GA_INITIALIZED) {
    ReactGA.initialize("G-FFKP7BBJ9S");
    window.GA_INITIALIZED = true;
}

export default function Analytics() {
    const location = useLocation();

    useEffect(() => {
        const pagePath = location.pathname + location.search;
        ReactGA.send({ hitType: "pageview", page: pagePath });
        console.log("GA Pageview:", pagePath);
    }, [location]);

    return null;
}
